module.exports = __webpack_public_path__ + "img/sowhatbuy-card-image.05c028e8.png";